// WhatsApp helper for GR a Cuchillo (640 13 92 17)
const PHONE = "34640139217"; // international format, no plus / spaces

export function whatsappUrl(message = "") {
  return `https://wa.me/${PHONE}?text=${encodeURIComponent(message)}`;
}

export function reservationMessage(t) {
  return (
    `${t?.whatsapp?.reservationIntro || "Hola, me gustaría reservar mesa en GR a Cuchillo."}\n\n` +
    `— ${t?.whatsapp?.fieldName || "Nombre"}:\n` +
    `— ${t?.whatsapp?.fieldGuests || "Personas"}:\n` +
    `— ${t?.whatsapp?.fieldDate || "Fecha y hora"}:\n` +
    `— ${t?.whatsapp?.fieldNotes || "Notas"}:\n\n` +
    `${t?.whatsapp?.thanks || "¡Gracias!"}`
  );
}

export function serviceMessage(t, serviceLabel) {
  return (
    `${t?.whatsapp?.serviceIntro || "Hola, quiero hacer un pedido"} (${serviceLabel}) en GR a Cuchillo.\n\n` +
    `— ${t?.whatsapp?.fieldName || "Nombre"}:\n` +
    `— ${t?.whatsapp?.fieldOrder || "Pedido"}:\n` +
    `— ${t?.whatsapp?.fieldTime || "Hora deseada"}:\n` +
    `— ${t?.whatsapp?.fieldAddress || "Dirección (si es a domicilio)"}:\n\n` +
    `${t?.whatsapp?.thanks || "¡Gracias!"}`
  );
}

export const WHATSAPP_DISPLAY = "640 13 92 17";
export const WHATSAPP_RAW = PHONE;
